import React from "react";
import "./basketballsummercamps.css";

import StaticPageHeaders from "../../Components/StaticPageHeaders";
import VideoBanner from "../../Components/VideoBanner/VideoBanner";
import Team from "../../Components/Team/Team";
import UnlimitedBannerCom from "../../Components/InstructionsCom/UnlimitedBannerCom";
import Gallery from "../../Components/Home/Gallery/Gallery";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";

import SummerCampsBlock from "../../Components/SummerCampsBlock/SummerCampsBlock";
import SummerCampsBlock2 from "../../Components/SummerCampsBlock2/SummerCampsBlock2";

import img1 from "../../Assets/Images/SummerCampPage/sc_1.png";
import img2 from "../../Assets/Images/SummerCampPage/sc_2.png";
import img3 from "../../Assets/Images/SummerCampPage/sc_3.png";
import img4 from "../../Assets/Images/SummerCampPage/sc_4.png";

import { useNavigate } from "react-router-dom";
import SEO from "../../Components/SEO";

const SuccessStoriesBlock = [
  {
    image: img1,
    name: "SCHEDULE",
    description: [
      "Camps are scheduled for one full week at a time and run from 9:00am-3:30pm (early drop-off available, 8:30am).",
      "At our camps, the morning is dedicated to skill development. We want the players to come out of camp with new knowledge of the game of basketball. We want them to be able to take skills that they learn and apply them in their games at camp and during their basketball season.",
      "After skill work in the morning, the schedule calls for lunch. We have a hot lunch menu that is set for the week and available for purchase. You may choose to bring your own lunch as well.",
    ],
    special_heading: "After Lunch, It's GAME TIME!",
    orders: "right",
  },
  {
    image: img2,
    name: "GAMES AND COMPETITION",
    description: [
      "At Shootin' School, we have ongoing competitions, contests and tournaments throughout the week.",
      "First is our Knockout Challenge. Players participate in 4 different knockouts throughout the week! Each winner is awarded a trophy at the end of the week and a chance to win an additional prize.",
      "Next is our Shootin' School Camp Honor Roll Board. Players compete for a spot a the top of 7 different events. The players can choose to participate in whatever events they want for the allotted time. If at the end of the week they are at the top of any of the 7 categories, they will be awarded with a certificate and chance to win an additional prize!",
      "Throughout the week we have two ongoing tournaments. We have our 1 on1 Tournament and our Team Tournament. Players and teams go head-to-head in each tournament until the end of the week when we crown our champions, we give them trophies and a chance to win an additional prize!",
    ],
    special_heading: "",
    orders: "left",
  },
];

const SuccessStoriesBlocktwo = [
  {
    image: img3,
    name1: "SAFETY",
    description1:
      "All weeks of camp are staffed with a nurse or physical therapist.",
    name2: "GIVING BACK",
    description2:
      "For the past 5 years we have done a “Give Back Day” where we ask players to bring in canned goods or boxed goods for the CYO Food Pantry. Kids love giving back to the community and at the end of the summer, on occasion, the Staten Island Advance posts our pictures in the local newspaper!",
    orders: "right",
  },
  {
    image: img4,
    name1: "JERSEY DAY",
    description1:
      "Lastly, we have our weekly “ Wear Your Favorite Jersey to Camp Day ” where players wear their favorite jersey or a Shootin’ School Jersey to camp! The pictures on “Wear Your Favorite Jersey to Camp Day” are always AWESOME and the kids are always pumped up to rep’ their favorite teams and players…even if its their own team or their own jersey!",
    name2: "AWARD CEREMONY",
    description2:
      "On the final day of camp, we hold an Award Ceremony to honor all of our champions, award winners, and player standouts. No one goes home empty handed. All players are presented with a Shootin’ School Report Card and Shootin’ School Basketball!",
    orders: "left",
  },
];

const BasketBallSummerCamps = () => {
  const navigate = useNavigate();
  return (
    // <iframe width="560" height="315" src="https://www.youtube.com/embed/6Ygg_pLMBSs?si=pUWbMOwwP4pKSB68" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    <>
      <SEO
        title="Basketball Summer Camps - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/basketball-summer-camps"
      />
      <div className="team-page">
        <StaticPageHeaders title="BasketBall Summer Camps" />
        <VideoBanner
          videoUrl="https://www.youtube.com/embed/6Ygg_pLMBSs?si=pUWbMOwwP4pKSB68"
          heading="Our Summer Camp is one of the most popular on"
          subheading="Staten Island!"
          buttonText="Summer Camp Registration"
          buttonLink="/basketball-summer-camps-details"
        />

        <div className="summer-container">
          <div className="summer-sss-layout bg-custom">
            <div className="sss-grid">
              {SuccessStoriesBlock.map((successstory, i) => (
                <SummerCampsBlock
                  key={i}
                  image={successstory.image}
                  name={successstory.name}
                  description={successstory.description}
                  order={successstory.orders}
                  specialHeading={successstory.special_heading}
                />
              ))}
            </div>

            <div className="sss-grid" style={{ marginTop: "30px" }}>
              {SuccessStoriesBlocktwo.map((successstory, i) => (
                <SummerCampsBlock2
                  key={i}
                  image={successstory.image}
                  name1={successstory.name1}
                  description1={successstory.description1}
                  name2={successstory.name2}
                  description2={successstory.description2}
                  order={successstory.orders}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="summer-container">
          <div className="summer-sss-layout bg-custom">
            <div className="summer-sss-layout-header">
              <button
                className="vb-btn my-class-btn"
                onClick={() => navigate("/basketball-summer-camps-details")}
              >
                <span className="text-clip">Summer Camp Registration</span>
              </button>
            </div>
          </div>
        </div>
        <UnlimitedBannerCom brValue={1.28} />
        <div style={{ filter: "brightness(1.28)" }}>
          <Gallery />
        </div>
        <Sponsors />
      </div>
    </>
  );
};

export default BasketBallSummerCamps;
